import { configureStore } from "@reduxjs/toolkit";
import thunk from "redux-thunk";
import reducer from "./reducer";

const gaxios = require("gaxios");
gaxios.instance.defaults = {
  baseURL: process.env.REACT_APP_API_DOMAIN,
};
const { request } = gaxios;

const storage = {
  get(key) {
    // console.log('get', key);
    return sessionStorage.getItem(key);
  },
  set(key, value) {
    // console.log('set', key, value);
    sessionStorage.setItem(key, value);
  },
  remove(key) {
    sessionStorage.removeItem(key);
  }
};

export default function configureAppStore(preloadedState) {
  const middleware = [];
  const enhancers = [];

  middleware.push(thunk.withExtraArgument({ request, storage }));

  if (process.env.NODE_ENV === "development") {
    const { logger } = require("redux-logger");
    middleware.push(logger);
  }

  if (process.env.NODE_ENV === "development") {
    enhancers.push(require("./redux/enhancers/monitorReducer").default);
  }

  const store = configureStore({
    reducer,
    middleware,
    preloadedState,
    enhancers,
  });

  if (process.env.NODE_ENV === "development" && module.hot) {
    module.hot.accept("./reducer.js", () => store.replaceReducer(reducer));
  }

  return store;
}
